<template>
  <i v-safe-class="classList" class="icon" :style="{ 'font-size': props.size, color: props.color }"></i>
</template>
<script setup lang="ts">
import { Color, ColorVariants } from "@medapro-types/common/common";
import { computed } from "vue";
import { vSafeClass } from "@/plugins/directives/safeDirectives";
const props = withDefaults(defineProps<{ icon: string; variant?: ColorVariants; size?: string; color?: Color; coreUi?: boolean }>(), {
  icon: "WIP-Placeholder-Icon",
  size: "16px",
  coreUi: false
});

const classList = computed(() => {
  const result = [];

  if (!props.icon || "WIP-Placeholder-Icon" == props.icon || "WIP" == props.icon) {
    result.push(`mdp-WIP-Placeholder-Icon`);
    result.push(`text-debug`);
  } else {
    if (props.variant) result.push(`text-${props.variant}`);
    if (props.coreUi) result.push(`cil-${props.icon}`);
    else result.push(`mdp-${props.icon}`);
  }
  return result;
});
</script>
